import React from 'react';

const TermsContent = () => (
    <div>
        <h2>Terms of Service</h2>

        <p>Welcome to our management system! Please read the following terms of service carefully:</p>

        <h3>Use of the System:</h3>
        <p>Your use of the system is subject to the terms of service and privacy policy detailed below.</p>

        <h3>WhatsApp Messages:</h3>
        <p>This system utilizes the WhatsApp API for the purpose of sending messages via WhatsApp. Messages sent are not intended for spam and are only dispatched in cases where alerts or reminders related to system actions are necessary.</p>

        <h3>Data Retention:</h3>
        <p>The system will retain the information you provide in order to facilitate the services offered by the system. We are committed to preserving your privacy and will not share your information with third parties without your consent.</p>

        <h3>Disclaimer of Liability:</h3>
        <p>The use of this system is at your own risk. We shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to or use of the system.</p>

        <h3>Intellectual Property:</h3>
        <p>All content included in the system, such as text, graphics, logos, button icons, images, audio clips, and software, is the property of our business and is protected by copyright laws.</p>

        <h3>Changes to Terms:</h3>
        <p>We reserve the right to update or modify these terms of service at any time without prior notice. Your continued use of the system after any such changes constitutes your acceptance of the new terms.</p>

        <h3>Contact Information:</h3>
        <p>If you have any questions or concerns about these terms of service, please contact us at support@example.com.</p>
    </div>
);

export default TermsContent;
